var _path;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

var SvgReply = function SvgReply(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m2.389 11.215 7.992-6.082a.604.604 0 0 1 .428-.13.606.606 0 0 1 .401.2.622.622 0 0 1 .157.425v3.204c8.712 0 10.363 6.133 10.632 9.413a.64.64 0 0 1-.175.474.621.621 0 0 1-.461.194.623.623 0 0 1-.454-.211c-3.867-4.583-9.542-3.526-9.542-3.526v3.204a.622.622 0 0 1-.157.418.603.603 0 0 1-.818.077l-8.003-6.08a.993.993 0 0 1-.389-.79c0-.31.144-.603.389-.79Z"
  })));
};

export default SvgReply;